import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useQuery } from 'react-query';

const useCompanyType = (companyTypeId) => {
  const { data, isLoading, error, refetch } = useQuery(
    ['companyType', companyTypeId], // Include companyTypeId in query key for proper caching
    async () => {
      if (!companyTypeId) {
        return null; // Don't make API call if companyTypeId is not available
      }
      return await axios.get(`company_type/get_companyType/${companyTypeId}`, {
        withCredentials: true,
      });
    },
    {
      enabled: !!companyTypeId, // Only fetch when companyTypeId is available
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes
      refetchOnMount: 'always', // Always refetch on mount, but staleTime prevents if data is fresh
      refetchOnWindowFocus: false, // Don't refetch when window gains focus
      retry: 2, // Retry twice on failure
      onError: (error) => {
        console.error('Error fetching company type data:', error);
      },
    }
  );
  return { data, isLoading, error, refetch };
};

export default useCompanyType;


